<template>
  <div class="form-check d-flex align-items-center gap-2">
    <input :id="id || name" class="form-check-input m-0" type="radio" :name="name" :checked="checked"
      @change="$emit('update:checked', $event.target.checked)" />
    <label class="form-check-label d-flex align-items-center" :for="id">
      <slot class="mx-0 my-auto"/>
      <Tooltip v-if="toolTipHeading && toolTipHeading != ''" :heading="toolTipHeading" :paragraph="toolTipDescription" class="ms-1" />
    </label>
  </div>
</template>

<script>
import Tooltip from "./Tooltip.vue";

export default {
  name: "MaterialRadio",
  components: { Tooltip },
  props: {
    name: {
      type: String,
      required: true,
    },
    id: {
      type: String,
      // required: true,
    },
    checked: {
      type: Boolean,
      default: false,
    },
    toolTipHeading: {
      type: String,
      default: '',
    },
    toolTipDescription: {
      type: String,
      default: '',
    },
  },
  emits: ["update:checked"],
};
</script>

<style scoped>
.form-check-input:checked::after {
  background-color: #007bff !important;
  border-color: #007bff !important;
  background-image: none !important;
  margin: auto !important;
}

.form-check:not(.form-switch) .form-check-input[type=radio]:after {
  background-image: none !important;
  width: 1rem !important;
  height: 1rem !important;
  margin: auto !important;
}
</style>
